import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
    useId,
    useRef,
    useState,
} from 'react';

import {
    useClickOutside,
} from 'tools/hooks';

import {
    ErrorMessage,
} from 'components/other';

import arrowImage from './media/arrow.svg';

import styles from './SelectInput.module.scss';

const SelectInput: FC<IProps> = (props) => {
    const [domRect, setDomRect] = useState<DOMRect | null>(null);

    const id = useId();

    const containerRef = useRef<HTMLDivElement>(null);

    const onClick = () => {
        if (props.isDisabled) {
            return;
        }
        if (!containerRef.current) {
            return;
        }
        if (domRect) {
            setDomRect(null);

            return;
        }

        const newDomRect = containerRef.current.getBoundingClientRect();

        setDomRect(newDomRect);
    };
    const onClickValue = (value: string) => {
        props.onChangeValue?.(value);
        setDomRect(null);
    };

    useClickOutside(containerRef, () => {
        setDomRect(null);
    });

    return (
        <div
            ref={containerRef}
            className={
                classNames(styles.selectInput, props.className, {
                    [styles.isSmall]: props.size === 'small',
                    [styles.isOpen]: !!domRect,
                    [styles.isDisabled]: props.isDisabled,
                    [styles.isError]: props.isError,
                })
            }
        >
            {
                props.label &&
                <label
                    htmlFor={id}
                    className={styles.label}
                >
                    {props.label}
                </label>
            }
            <div
                id={id}
                className={styles.value}
                onClick={onClick}
            >
                {props.formatValue?.(props.value) || props.value || '-'}
                <img
                    className={styles.arrowImage}
                    src={arrowImage}
                    alt={''}
                />
            </div>
            {
                domRect &&
                !props.isDisabled &&
                <div
                    className={styles.options}
                    style={{
                        top: domRect.bottom,
                        left: domRect.left,
                        right: domRect.right,
                        width: domRect.width,
                    }}
                >
                    {
                        props.values.map(
                            (value) =>
                                <div
                                    key={value}
                                    className={styles.option}
                                    onClick={() => onClickValue(value)}
                                >
                                    {props.formatValue?.(value) ?? value}
                                </div>
                        )
                    }
                </div>
            }
            <ErrorMessage
                className={styles.errorMessage}
                text={props.errorMessage ?? ''}
            />
        </div>
    );
};

export default SelectInput;
